import React from 'react';

function ComingSoonFooter() {
  return (
    <footer
      style={{
        marginTop: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: '35px',
        padding: '0 5vw',
        paddingBottom: 'env(safe-area-inset-bottom)',
        background: 'rgba(235, 235, 235, 0.8)',
      }}
    >
      <div style={{ fontSize: '12px', color: '#5a5a5a' }}>
        © 2026 SingleCombo • All rights reserved.
      </div>
    </footer>
  );
}

export default ComingSoonFooter;
